var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF4C4C;}\n\t.st1{fill:#FDFEFD;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1000.7,0c551.1,0.3,999.4,449.1,999.3,1000.2c-0.1,551.7-450,1000.8-1001.7,999.8 C446.5,1999-1,1549.3,0,996.8C1,447.3,450.4-0.3,1000.7,0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1461.7,1258.1L1203.7,1000l258.1-258.1c13.1-13.1,13.1-34.4,0-47.5l-156.2-156.2c-13.1-13.1-34.4-13.1-47.5,0 L1000,796.3L741.9,538.3c-13.1-13.1-34.4-13.1-47.5,0L538.3,694.5c-13.1,13.1-13.1,34.4,0,47.5L796.3,1000l-258.1,258.1 c-13.1,13.1-13.1,34.4,0,47.5l156.2,156.2c13.1,13.1,34.4,13.1,47.5,0l258.1-258.1l258.1,258.1c13.1,13.1,34.4,13.1,47.5,0 l156.2-156.2C1474.8,1292.4,1474.8,1271.2,1461.7,1258.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.cce105a4abc6dd8e295f7f1c08ecab32.svg";
export { ForwardRef as ReactComponent };